<template>
    <div :class="isMobile ? 'productDetail-m' : 'productDetail'">
      <el-breadcrumb separator="/" class="bread">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/plan' }">解决方案</el-breadcrumb-item>
        <el-breadcrumb-item>解决方案详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div v-if="isShow">
        <div v-if="thisObj.styleType==1">
          <el-row class="part" >
            <el-col :span="isMobile ? 24 : 8" class="imgPart">
              <img class="bigImg" :src="require(`./../../assets/project/${thisObj.imgUrl}`)" />
            </el-col>
            <el-col :span="isMobile ? 22 : 14" :offset="isMobile ? 0 : 2">
              <div>
                <div class="title">{{thisObj.name}}</div>
                <div v-for="(item, index) in thisObj.introduction" :key="index">
                  <div class="subtitle">{{ item.name }}</div>
                  <div v-show="item.text" class="text" v-for="(obj, i) in item.text" :key="i">{{obj}}</div>
                  <el-table
                    v-if="item.table"
                    :data="item.table.body"
                    border
                    style="width: 100%">
                    <el-table-column
                      v-for="(obj, i) in item.table.header"
                      :prop="obj"
                      :label="obj">
                      <template slot-scope="scope">
                        <div v-html="scope.row[obj]"></div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <img style="max-width: 100%" v-if="item.imgUrl" 
                    :src="require(`./../../assets/project/detail/${item.imgUrl}`)"
                    />
                </div>
                <a v-show="thisObj.taobaoHref" :href="thisObj.taobaoHref" target="_blank" class="toPdf">淘宝购买</a>
                <a v-show="thisObj.href" :href="thisObj.href" target="_blank" class="toPdf">产品说明书</a>
                <div class="connectMethod">
                  <img class="icon" src="./../../assets/homeIcon/phone-small.png" />
                  <span class="phone">15255615034</span>
                </div>
              </div>
            </el-col>
          </el-row>

          <div class="detail">
            <div v-for="(item, index) in thisObj.detail" :key="index">
              <div class="subtitle">{{ item.name }}</div>
              <div v-show="item.text" class="text" v-for="(obj, i) in item.text" :key="i">{{obj}}</div>
              <el-table
                v-if="item.table"
                :data="item.table.body"
                border
                style="width: 100%">
                <el-table-column
                  v-for="(obj, i) in item.table.header"
                  :prop="obj"
                  :label="obj">
                </el-table-column>
              </el-table>
              <img style="max-width: 100%" v-if="item.imgUrl" 
                :src="require(`./../../assets/project/detail/${item.imgUrl}`)"
                />
            </div>
          </div>
        </div>
        <div class="style2" v-else>
          <div class="planName">{{ thisObj.name }}</div>
          <div v-for="(item, index) in thisObj.detail" :key="index">
            <div class="title">{{item.name}}</div>
            <div v-show="item.text" class="text" v-for="(obj, i) in item.text" :key="i">{{obj}}</div>
            <el-table
              v-if="item.table"
              :data="item.table.body"
              border
              style="width: 100%">
              <el-table-column
                v-for="(obj, i) in item.table.header"
                :prop="obj"
                :label="obj">
              </el-table-column>
            </el-table>
            <img style="max-width: 100%;margin: 0 auto;display: block;" v-if="item.imgUrl" 
              :src="require(`./../../assets/project/detail/${item.imgUrl}`)"
              />
            <div v-if="item.advlist">
              <div class="adv-box listFor4" v-if="item.advlist && item.advlist.length==4">
                <img src="./../../assets/project/detail/adv-bg.png" class="adv-bg" />
                <div :class="['one-img', 'one-img'+(i), advCurIndex==i-1?'active':'']" 
                      v-for="i in 4"  @mouseenter="changeAdvIndex(i-1)">
                  <img :src="require('./../../assets/project/detail/adv-icon0'+(i)+'.png')" />
                </div>
                  <div :class="'one-title one-title'+(i)"
                    v-for="i in 4">
                    <SlideUpComponent :offset="20" :once="false">
                      {{ item.advlist[i-1].title }}
                    </SlideUpComponent>
                  </div>
                
                <div class="one-content">
                  <div class="one-con-tit" >
                    <SlideUpComponent :offset="40" :once="false">
                      {{ item.advlist[advCurIndex].title }}
                    </SlideUpComponent>  
                  </div>
                  <div class="one-con-text" v-for="one in item.advlist[advCurIndex].text">
                    <SlideUpComponent :offset="60" :once="false">
                      {{ one }}
                    </SlideUpComponent>  
                  </div>
                </div>
              </div>
              <div class="adv-box listFor3" v-else-if="item.advlist && item.advlist.length==3">
                <img src="./../../assets/project/detail/adv-bg.png" class="adv-bg" />
                <div :class="['one-img', 'one-img'+(i), advCurIndex==i-1?'active':'']" 
                      v-for="i in 3" @click="changeAdvIndex(i-1)">
                  <img :src="require('./../../assets/project/detail/adv-icon0'+(i)+'.png')" />
                </div>
                  <div :class="'one-title one-title'+(i)" v-for="i in 3">
                    <SlideUpComponent :offset="20" :once="false">
                      {{ item.advlist[i-1].title }}
                    </SlideUpComponent>
                  </div>

                <div class="one-content">
                  <div class="one-con-tit">
                    <SlideUpComponent :offset="40" :once="false">
                      {{ item.advlist[advCurIndex].title }}
                    </SlideUpComponent>
                  </div>
                  <div class="one-con-text" v-for="one in item.advlist[advCurIndex].text">
                    <SlideUpComponent :offset="60" :once="false">
                      {{ one }}
                    </SlideUpComponent>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="item.valuelist">
              <el-row :gutter="20">
                <el-col :span="isMobile ? 24 : item.valuelist && item.valuelist.length==3 ? 8 : 6" v-for="one in item.valuelist" class="value-one">
                  <SlideUpComponent :offset="20" :once="false">
                    <img :src="require(`./../../assets/project/detail/${one.imgurl}`)" class="value-one-img" />
                  </SlideUpComponent>
                  <div class="value-one-title">
                    <SlideUpComponent :offset="20" :once="false">{{ one.title }}</SlideUpComponent>
                  </div>
                  <div class="value-one-text" v-for="o in one.text">
                    <SlideUpComponent :offset="40" :once="false">{{ o }}</SlideUpComponent>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>

    </div>
  </template>
  
  <script>
  import arrJson from "../../utils/arrJson"
  import SlideUpComponent from '@/components/SlideUpComponent.vue'

  export default {
    name: 'PlanDetail',
    components: {
      SlideUpComponent
    },
    data() {
      return {
        isMobile: window.innerWidth < 780,
        id: null,
        isShow: false,
        thisObj: {},
        advCurIndex: 0
      }
    },
    mounted() {
      this.getDetail()
      window.addEventListener("resize", this.initFunc)
    },
    destroyed() {
      window.removeEventListener("resize", this.initFunc)
    },
    methods: {
      getDetail() {
        let parentId = null
        const pathList = this.$router.currentRoute.path.split("/") // 取url上的id
        this.id = pathList[pathList.length-1]
        parentId = this.id.split("")[1] //取父级index，“012”，父级为“1”
        const index = arrJson.planList[parentId].data.findIndex(item => item.id+""===this.id+"")
        this.thisObj = arrJson.planList[parentId].data[index]
        this.isShow = true
      },
      changeAdvIndex(index){
        this.advCurIndex = index
      },
      initFunc() {
        this.isMobile = window.innerWidth < 780
      }
    },
    props: {
      msg: String
    }
  }
  </script>
  
  
  <style scoped lang="less">
    /deep/ .el-breadcrumb__inner.is-link{
      font-weight: normal;
    }
    .productDetail{
      max-width: 1100px;
      margin: 0 auto 60px;
      .bread{
        line-height: 50px;
        margin-top: 20px;
      }
      .part{
        text-align: left;
        .imgPart{
          background: #d6dde8;
          text-align: center;
        }
        .bigImg{
          max-width: 100%;
          max-height: 400px;
          display: block;
          margin: 0 auto;
        }
        .title{
          font-size: 26px;
          line-height: 40px;
        }
        .subtitle{
          font-size: 16px;
          color: #244c6e;
          font-weight: bold;
          line-height: 40px;
          margin-top: 20px;
        }
        .text{
          font-size: 16px;
          line-height: 30px;
          text-align: left;
          color: #6f6f6f;
          text-indent: 32px;
        }
        .toPdf{
          font-size: 14px;
          color: #fff;
          display: inline-block;
          border-radius: 20px;
          padding: 12px 40px;
          margin: 16px 10px 0 0;
          background: #384C5C;
          cursor: pointer;
        }
        .connectMethod{
          padding: 0 0 0 12px;
          display: inline-block;
          vertical-align: sub;
          margin-top: 20px;
          .icon{
            width: 20px;
            height: 20px;
          }
          .phone{
            color: #00d0ff;
            line-height: 22px;
            display: inline-block;
            vertical-align: top;
            margin-left: 4px;
            font-size: 18px;
          }
        }
      }
      .detail{
        text-align: center;
        .subtitle{
          font-size: 16px;
          color: #244c6e;
          font-weight: bold;
          line-height: 40px;
          margin-top: 20px;
          text-align: left;
        }
        .text{
          font-size: 16px;
          line-height: 30px;
          text-align: left;
          color: #6f6f6f;
          text-indent: 32px;
        }

      }
      .style2{
        .planName{
          font-size: 36px;
          line-height: 100px;
          text-align: center;
          color: #313E47;
        }
        .title{
          font-size: 32px;
          font-weight: bold;
          text-align: center;
          line-height: 100px;
          margin-top: 100px;
          margin-bottom: 30px;
          color: #313E47;
        }
        .text{
          font-size: 16px;
          line-height: 24px;
          text-align: center;
        }
        .adv-box{
          position: relative;
          .adv-bg{
            width: 70%;
            z-index: -1;
            margin: 20px auto;
            display: block;
          }
          .one-img{
            border: 1px solid #00d0ff;
            padding: 16px;
            display: inline-block;
            border-radius: 50%;
            width: 60px;
            height: 60px;
            box-sizing: border-box;
            background-color: #fff;
            img{
              width: 26px;
              height: 26px;
            }
          }
          .active{
            box-shadow: inset 0 0 0 3px #00d0ff;
          }
          .one-title{
            font-size: 18px;
          }
          .one-content{
            width: 40%;
            text-align: center;
            position: absolute;
            top: 42%;
            left: 50%;
            margin-left: -20%;
            .one-con-tit{
              font-size: 24px;
              line-height: 60px;
            }
            .one-con-text{
              font-size: 18px;
              line-height: 30px;
            }
          }
        }
        .listFor3{
          .one-img1{
            position: absolute;
            bottom: 10%;
            left: 15%;
          }
          .one-title1{
            position: absolute;
            bottom: 14%;
            left: 1%;
            width: 140px;
            text-align: right;
          }
          .one-img2{
            position: absolute;
            top: 4%;
            left: 47%;
          }
          .one-title2{
            position: absolute;
            top: -6%;
            left: 50%;
            width: 160px;
            margin-left: -80px;
            text-align: center;
          }
          .one-img3{
            position: absolute;
            bottom: 10%;
            right: 15%;
          }
          .one-title3{
            position: absolute;
            bottom: 14%;
            right: 1%;
            width: 140px;
            text-align: left;
          }
        }
        .listFor4{
          .one-img1{
            position: absolute;
            bottom: 10%;
            left: 15%;
          }
          .one-title1{
            position: absolute;
            bottom: 14%;
            left: 1%;
            width: 140px;
            text-align: right;
          }
          .one-img2{
            position: absolute;
            top: 22%;
            left: 27%;
          }
          .one-title2{
            position: absolute;
            width: 150px;
            top: 13%;
            left: 17%;
            text-align: right;
          }
          .one-img3{
            position: absolute;
            top: 22%;
            right: 27%;
          }
          .one-title3{
            position: absolute;
            width: 162px;
            top: 14%;
            right: 12%;
            text-align: left;
          }
          .one-img4{
            position: absolute;
            bottom: 10%;
            right: 15%;
          }
          .one-title4{
            position: absolute;
            width: 140px;
            bottom: 14%;
            right: 1%;
            text-align: left;
          }
        }
        .value-one{
          text-align: center;
          .value-one-img{
            width: 17%;
            margin: 40px 0 20px;
          }
          .value-one-title{
            font-size: 24px;
            line-height: 50px;
            padding: 0 20%;
          }
          .value-one-text{
            font-size: 16px;
            line-height: 30px;
            padding: 0 18%;
          }
        }
      }
    }
    .productDetail-m{
      margin: 0 0.4rem 1rem;
      /deep/ .el-breadcrumb{
        font-size: 0.4rem;
      }
      .bread{
        line-height: 1.2rem;
      }
      .part{
        text-align: left;
        .imgPart{
          padding: 0.1rem;
          background: #d6dde8;
          text-align: center;
        }
        .bigImg{
          max-width: 90%;
          max-height: 10rem;
          display: block;
          margin: 0 auto;
        }
        .title{
          font-size: 0.46rem;
          line-height: 0.9rem;
          margin-top: 0.4rem;
        }
        .subtitle{
          font-size: 0.38rem;
          color: #244c6e;
          font-weight: bold;
          line-height: 0.6rem;
          margin-top: 0.6rem;
        }
        .text{
          font-size: 0.38rem;
          line-height: 0.7rem;
          text-align: left;
          color: #6f6f6f;
          text-indent: 0.7rem;
        }
        .toPdf{
          margin: 0.46rem 0;
          display: block;
          color: #0089fe;
          font-size: 0.4rem;
        }
      }
      .style2{
        .title{
          font-size: 0.46rem;
          font-weight: bold;
          text-align: center;
          line-height: 1.4rem;
          margin-top: 1rem;
        }
        .text{
          font-size: 0.36rem;
          line-height: 0.6rem;
          text-align: center;
        }
        .adv-box{
          position: relative;
          width: 140%;
          margin-left: -20%;
          .adv-bg{
            width: 70%;
            z-index: -1;
            margin: 0.4rem auto;
            display: block;
          }
          .one-img{
            border: 1px solid #00d0ff;
            text-align: center;
            display: flex;
            align-items: center;  /* 垂直居中 */
            justify-content: center; 
            border-radius: 50%;
            width: 1.2rem;
            height: 1.2rem;
            box-sizing: border-box;
            background-color: #fff;
            img{
              width: 0.52rem;
              height: 0.52rem;
            }
          }
          .active{
            box-shadow: inset 0 0 0 0.06rem #00d0ff;
          }
          .one-title{
            display: none;
          }
          .one-content{
            width: 40%;
            text-align: center;
            position: absolute;
            top: 46%;
            left: 50%;
            margin-left: -20%;
            .one-con-tit{
              font-size: 0.4rem;
              line-height: 0.6rem;
            }
            .one-con-text{
              font-size: 0.32rem;
              line-height: 0.5rem;
            }
          }
        }
        .listFor3{
          .one-img1{
            position: absolute;
            bottom: 10%;
            left: 14%;
          }
          .one-title1{
            position: absolute;
            bottom: 14%;
            left: 1%;
            width: 140px;
          }
          .one-img2{
            position: absolute;
            top: 0%;
            left: 47%;
          }
          .one-title2{
            position: absolute;
            top: -4%;
            left: 50%;
            width: 160px;
            margin-left: -80px;
          }
          .one-img3{
            position: absolute;
            bottom: 10%;
            right: 14%;
          }
          .one-title3{
            position: absolute;
            bottom: 14%;
            right: 1%;
            width: 140px;
          }
        }
        .listFor4{
          .one-img1{
            position: absolute;
            bottom: 10%;
            left: 14%;
          }
          .one-title1{
            position: absolute;
            bottom: 14%;
            left: 1%;
            width: 140px;
          }
          .one-img2{
            position: absolute;
            top: 14%;
            left: 27%;
          }
          .one-title2{
            position: absolute;
            width: 150px;
            top: 13%;
            left: 17%;
          }
          .one-img3{
            position: absolute;
            top: 14%;
            right: 27%;
          }
          .one-title3{
            position: absolute;
            width: 162px;
            top: 14%;
            right: 12%;
          }
          .one-img4{
            position: absolute;
            bottom: 10%;
            right: 14%;
          }
          .one-title4{
            position: absolute;
            width: 140px;
            bottom: 14%;
            right: 1%;
          }
        }
        .value-one{
          text-align: center;
          .value-one-img{
            width: 12%;
            margin: 1rem 0 0.1rem;
          }
          .value-one-title{
            font-size: 0.48rem;
            line-height: 1rem;
            padding: 0 20%;
          }
          .value-one-text{
            font-size: 0.32rem;
            line-height: 0.6rem;
            padding: 0 18%;
          }
        }
      }
    }
  
  
  </style>